import React, { useEffect, useState } from 'react';
import './HomePage.scss';
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import { isAutoServicesTenant } from '../../../utils/tenantBranding';
 
const staticMediaData = {
  data: [
    {
      id: 'static_1',
      media_type: 'IMAGE',
      media_url: 'https://images.unsplash.com/photo-1552519507-da3b142c6e3d',
      permalink: 'https://example.com/static1',
      caption: 'Engine parts and maintenance',
      timestamp: new Date().toISOString()
    },
    {
      id: 'static_2',
      media_type: 'IMAGE',
      media_url: 'https://images.unsplash.com/photo-1581090700227-1e37b190418e',
      permalink: 'https://example.com/static2',
      caption: 'Professional bus repair services',
      timestamp: new Date().toISOString()
    },
    {
      id: 'static_3',
      media_type: 'IMAGE',
      media_url: 'https://images.unsplash.com/photo-1570129477492-45c003edd2be',
      permalink: 'https://example.com/static3',
      caption: 'Expert car polishing service',
      timestamp: new Date().toISOString()
    },

  ]
};
 
// Instagram API endpoint
const INSTAGRAM_API_URL = "https://graph.facebook.com/v19.0/17841473493391573/media?fields=id,caption,media_type,media_url,permalink,timestamp&access_token=EAAjZCvZBtpQMYBPSWqSqNZBCXViZANj9Sa1mHxK15T27BfbFJ0acZCIRAwtwpzwL5wkn7GLjj2i76cNBjGFFMzjS4tM95xyPjGebZA89sP5SDWVkiOlu7JpReZCP1n094mZByGkqlEjOV8Twea2u4hIjWKHUxCyGzloVqXNkru5laz1Yg2THwhHSxO9L3QZDZD";

const InstagramCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [slidesToShow, setSlidesToShow] = useState(3);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [media, setMedia] = useState<any[]>([]);
  
  const fetchingTenant = window.location.hostname.split(".")[0];
  const isAutoservices = isAutoServicesTenant(fetchingTenant);
  
  useEffect(() => {
    const updateSlides = () => {
      if (window.innerWidth < 600) setSlidesToShow(1);
      else if (window.innerWidth < 960) setSlidesToShow(2);
      else setSlidesToShow(3);
    };
    updateSlides();
    window.addEventListener("resize", updateSlides);
    return () => window.removeEventListener("resize", updateSlides);
  }, []);

  useEffect(() => {
    if (isAutoservices) {
      // Use static data for autoservices tenant
      setMedia(staticMediaData.data);
      setLoading(false);
    } else {
      // Fetch from Instagram API for other tenants
      const fetchInstagramMedia = async () => {
        setLoading(true);
        setError(null);
        try {
          const res = await fetch(INSTAGRAM_API_URL);
          const data = await res.json();
          if (data?.data) {
            setMedia(data.data.filter((item: any) => 
              item.media_type === "IMAGE" || 
              item.media_type === "CAROUSEL_ALBUM" || 
              item.media_type === "VIDEO" || 
              item.media_type === "REEL"
            ));
          } else {
            setMedia([]);
          }
        } catch (err: any) {
          setError("Failed to fetch Instagram media");
          console.error("Instagram API error:", err);
        } finally {
          setLoading(false);
        }
      };
      fetchInstagramMedia();
    }
  }, [isAutoservices]);

  const totalSlides = media?.length;
 
  const nextSlide = () => {
    if (currentIndex < totalSlides - slidesToShow) {
      setCurrentIndex(currentIndex + 1);
    }
  };
 
  const prevSlide = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  const handleMediaClick = (e: React.MouseEvent, item: any, isVideo: boolean) => {
    e.stopPropagation();
    // Only open in new tab if not clicking on video controls
    if (isVideo && (e.target as HTMLElement).tagName === 'VIDEO') {
      return; // Let the video controls work normally
    }
    // Open the Instagram post URL if available, otherwise fallback to media URL
    const url = item.permalink || item.media_url;
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const renderMediaItem = (item: any, index: number) => {
    const isVideo = item.media_type === "VIDEO" || item.media_type === "REEL";
    
    return (
      <div
        className="carousel-card"
        key={index}
        style={{ flex: `0 0 ${100 / slidesToShow}%` }}
        onClick={(e) => handleMediaClick(e, item, isVideo)}
      >
        <div className="media-container">
          {isVideo ? (
            <video 
              className="media-content"
              controls
              preload="metadata"
              poster={item.thumbnail_url || ''}
              playsInline
              webkit-playsinline="true"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'contain',
                cursor: 'pointer'
              }}
              onClick={(e) => e.stopPropagation()} // Prevent parent click when clicking video
            >
              <source src={item.media_url} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          ) : (
            <img 
              className="media-content" 
              src={item.media_url} 
              alt={`Instagram ${index + 1}`}
              loading="lazy"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'contain',
                cursor: 'pointer'
              }}
            />
          )}
          {isVideo && (
            <div className="video-overlay">
              <PlayArrowIcon className="play-icon" />
            </div>
          )}
        </div>
      </div>
    );
  };

  if (loading) {
    return (
      <div className="carousel-container">
        <h2 className="carousel-title">Our Latest on Instagram</h2>
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Loading Instagram content...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="carousel-container">
        <h2 className="carousel-title">Our Latest on Instagram</h2>
        <div className="error-container">
          <p>Unable to load Instagram content. Please try again later.</p>
        </div>
      </div>
    );
  }

  if (!media || media.length === 0) {
    return (
      <div className="carousel-container">
        <h2 className="carousel-title">Our Latest on Instagram</h2>
        <div className="no-content-container">
          <p>No Instagram content available at the moment.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="carousel-container">
      <h2 className="carousel-title">Our Latest on Instagram</h2>
 
      <div className="carousel-wrapper">
        <button 
          className="nav left" 
          onClick={prevSlide}
          disabled={currentIndex === 0}
        >
          <ChevronLeftIcon />
        </button>
 
        <div
          className="carousel-track"
          style={{
            transform: `translateX(-${currentIndex * (100 / slidesToShow)}%)`,
          }}
        >
          {media.map((item, i) => renderMediaItem(item, i))}
        </div>
 
        <button 
          className="nav right" 
          onClick={nextSlide}
          disabled={currentIndex >= totalSlides - slidesToShow}
        >
          <ChevronRightIcon />
        </button>
      </div>
 
      <div className="dots">
        {Array.from({ length: Math.max(1, totalSlides - slidesToShow + 1) }).map((_, i) => (
          <span
            key={i}
            className={`dot ${i === currentIndex ? "active" : ""}`}
            onClick={() => setCurrentIndex(i)}
          />
        ))}
      </div>
    </div>
  );
};

export default InstagramCarousel;
